import Vue from 'vue';
import Router from 'vue-router';
Vue.use(Router);

// 获取原型上的 push 函数
const originalPush = Router.prototype.push
// 修改原型对象中的 push 方法，捕获异常
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => {
    // 如果是重复导航的错误，则忽略它
    if (Router.isNavigationFailure(err, Router.NavigationFailureType.duplicated)) {
      return err
    }
    // 其他错误继续抛出
    return Promise.reject(err)
  })
}

// 同理，也可以重写 replace 方法
const originalReplace = Router.prototype.replace
Router.prototype.replace = function replace(location) {
  return originalReplace.call(this, location).catch(err => err)
}

const router = new Router({
  mode: 'history',
  routes: [
    // {
    //   path: '/',
    //   name: 'login',
    //   meta: {
    //     title: '首页'
    //   },
    //   component: resolve => {
    //     require(['@/pages/login.vue'], resolve)
    //   }
    // },
    {
      path: '/index',
      name: 'index',
      meta: {
        title: '首页'
      },
      component: resolve => {
        require(['@/pages/index.vue'], resolve)
      }
    },
    {
      path: '/login',
      name: 'login',
      meta: {
        title: '登录'
      },
      component: resolve => {
        require(['@/pages/login.vue'], resolve)
      }
    },
    {
      path: '/regUser',
      name: 'regUser',
      meta: {
        title: '注册用户'
      },
      component: resolve => {
        require(['@/pages/regUser.vue'], resolve)
      }
    },
    {
      path: '/userDetail',
      name: 'userDetail',
      meta: {
        title: '用户详情'
      },
      component: resolve => {
        require(['@/pages/userDetail.vue'], resolve)
      }
    },
    {
      path: '/agent',
      name: 'agent',
      meta: {
        title: '代理用户'
      },
      component: resolve => {
        require(['@/pages/agent.vue'], resolve)
      }
    },
    {
      path: '/agentDetail',
      name: 'agentDetail',
      meta: {
        title: '代理用户详情'
      },
      component: resolve => {
        require(['@/pages/agentDetail.vue'], resolve)
      }
    },
    {
      path: '/blacklist',
      name: 'blacklist',
      meta: {
        title: '黑名单'
      },
      component: resolve => {
        require(['@/pages/blacklist.vue'], resolve)
      }
    },
    {
      path: '/blackDetail',
      name: 'blackDetail',
      meta: {
        title: '黑名单详情'
      },
      component: resolve => {
        require(['@/pages/blackDetail.vue'], resolve)
      }
    },
    {
      path: '/commission',
      name: 'commission',
      meta: {
        title: '佣金设置'
      },
      component: resolve => {
        require(['@/pages/commission.vue'], resolve)
      }
    },
    {
      path: '/whiteList',
      name: 'whiteList',
      meta: {
        title: '白名单'
      },
      component: resolve => {
        require(['@/pages/whiteList.vue'], resolve)
      }
    },
    {
      path: '/nickNames',
      name: 'nickNames',
      meta: {
        title: '昵称审核'
      },
      component: resolve => {
        require(['@/pages/nickNames.vue'], resolve)
      }
    },
    {
      path: '/codeRecord',
      name: 'codeRecord',
      meta: {
        title: '验证码记录'
      },
      component: resolve => {
        require(['@/pages/codeRecord.vue'], resolve)
      }
    },
    {
      path: '/order',
      name: 'order',
      meta: {
        title: '商城订单'
      },
      component: resolve => {
        require(['@/pages/order.vue'], resolve)
      }
    },
    {
      path: '/orderDetail',
      name: 'orderDetail',
      meta: {
        title: '订单详情'
      },
      component: resolve => {
        require(['@/pages/orderDetail.vue'], resolve)
      }
    },
    {
      path: '/selforder',
      name: 'selforder',
      meta: {
        title: '自提订单'
      },
      component: resolve => {
        require(['@/pages/selforder.vue'], resolve)
      }
    },
    {
      path: '/selforderDetail',
      name: 'selforderDetail',
      meta: {
        title: '订单详情'
      },
      component: resolve => {
        require(['@/pages/selforderDetail.vue'], resolve)
      }
    },
    {
      path: '/winningOrder',
      name: 'winningOrder',
      meta: {
        title: '中奖兑奖商品订单'
      },
      component: resolve => {
        require(['@/pages/winningOrder.vue'], resolve)
      }
    },
    {
      path: '/winningOrderDetail',
      name: 'winningOrderDetail',
      meta: {
        title: '订单详情'
      },
      component: resolve => {
        require(['@/pages/winningOrderDetail.vue'], resolve)
      }
    },
    {
      path: '/exchangeOrder',
      name: 'exchangeOrder',
      meta: {
        title: '积分兑换订单'
      },
      component: resolve => {
        require(['@/pages/exchangeOrder.vue'], resolve)
      }
    },
    {
      path: '/exchangeOrderDetail',
      name: 'exchangeOrderDetail',
      meta: {
        title: '订单详情'
      },
      component: resolve => {
        require(['@/pages/exchangeOrderDetail.vue'], resolve)
      }
    },
    {
      path: '/groupBuying',
      name: 'groupBuying',
      meta: {
        title: '拼团商品'
      },
      component: resolve => {
        require(['@/pages/groupBuying/groupBuying.vue'], resolve)
      }
    },
    {
      path: '/groupBuyingList',
      name: 'groupBuyingList',
      meta: {
        title: '拼团订单'
      },
      component: resolve => {
        require(['@/pages/groupBuying/groupBuyingList.vue'], resolve)
      }
    },
    {
      path: '/updateGroupBuying',
      name: 'updateGroupBuying',
      meta: {
        title: '拼团商品表单'
      },
      component: resolve => {
        require(['@/pages/groupBuying/updateGroupBuying.vue'], resolve)
      }
    },
    {
      path: '/pointLottery',
      name: 'pointLottery',
      meta: {
        title: '积分抽奖'
      },
      component: resolve => {
        require(['@/pages/pointLottery/pointLottery.vue'], resolve)
      }
    },
    {
      path: '/pointLotteryList',
      name: 'pointLotteryList',
      meta: {
        title: '参与明细'
      },
      component: resolve => {
        require(['@/pages/pointLottery/pointLotteryList.vue'], resolve)
      }
    },
    {
      path: '/commodity',
      name: 'commodity',
      meta: {
        title: '商品管理'
      },
      component: resolve => {
        require(['@/pages/commodity.vue'], resolve)
      }
    },
    {
      path: '/activityComm',
      name: 'activityComm',
      meta: {
        title: '抽奖商品管理'
      },
      component: resolve => {
        require(['@/pages/activityComm.vue'], resolve)
      }
    },
    {
      path: '/pointRedemption',
      name: 'pointRedemption',
      meta: {
        title: '积分兑换商品管理'
      },
      component: resolve => {
        require(['@/pages/pointRedemption/pointRedemption.vue'], resolve)
      }
    },
    {
      path: '/pointRedemptionList',
      name: 'pointRedemptionList',
      meta: {
        title: '兑换记录'
      },
      component: resolve => {
        require(['@/pages/pointRedemption/pointRedemptionList.vue'], resolve)
      }
    },

    {
      path: '/exchangShoop',
      name: 'exchangShoop',
      meta: {
        title: '积分兑换商品管理'
      },
      component: resolve => {
        require(['@/pages/exchangShoop.vue'], resolve)
      }
    },
    {
      path: '/addActivityComm',
      name: 'addActivityComm',
      meta: {
        title: '添加活动商品'
      },
      component: resolve => {
        require(['@/pages/addActivityComm.vue'], resolve)
      }
    },
    {
      path: '/editActivityComm',
      name: 'editActivityComm',
      meta: {
        title: '编辑活动商品'
      },
      component: resolve => {
        require(['@/pages/editActivityComm.vue'], resolve)
      }
    },
    {
      path: '/addCommo',
      name: 'addCommo',
      meta: {
        title: '添加商品'
      },
      component: resolve => {
        require(['@/pages/addCommo.vue'], resolve)
      }
    },
    {
      path: '/editCommo',
      name: 'editCommo',
      meta: {
        title: '商品编辑'
      },
      component: resolve => {
        require(['@/pages/editCommo.vue'], resolve)
      }
    },
    {
      path: '/trademark',
      name: 'trademark',
      meta: {
        title: '商品标签管理'
      },
      component: resolve => {
        require(['@/pages/trademark.vue'], resolve)
      }
    },
    {
      path: '/carMy',
      name: 'carMy',
      meta: {
        title: '卡密管理'
      },
      component: resolve => {
        require(['@/pages/carMy.vue'], resolve)
      }
    },
    {
      path: '/operationLog',
      name: 'operationLog',
      meta: {
        title: '操作日志'
      },
      component: resolve => {
        require(['@/pages/operationLog.vue'], resolve)
      }
    },
    {
      path: '/role',
      name: 'role',
      meta: {
        title: '角色管理'
      },
      component: resolve => {
        require(['@/pages/role.vue'], resolve)
      }
    }, {
      path: '/account',
      name: 'account',
      meta: {
        title: '账号管理'
      },
      component: resolve => {
        require(['@/pages/account.vue'], resolve)
      }
    },
    {
      path: '/roleDetail',
      name: 'roleDetail',
      meta: {
        title: '修改'
      },
      component: resolve => {
        require(['@/pages/roleDetail.vue'], resolve)
      }
    },
    {
      path: '/category',
      name: 'category',
      meta: {
        title: '类目管理'
      },
      component: resolve => {
        require(['@/pages/category.vue'], resolve)
      }
    },
    //
    {
      path: '/luckyCategory',
      name: 'luckyCategory',
      meta: {
        title: '抽奖首页类目'
      },
      component: resolve => {
        require(['@/pages/luckyCategory.vue'], resolve)
      }
    },
    {
      path: '/luckyCateDetail',
      name: 'luckyCateDetail',
      meta: {
        title: '详情'
      },
      component: resolve => {
        require(['@/pages/luckyCateDetail.vue'], resolve)
      }
    },
    {
      path: '/popupManagement',
      name: 'popupManagement',
      meta: {
        title: '弹窗管理'
      },
      component: resolve => {
        require(['@/pages/popupManagement.vue'], resolve)
      }
    },
    {
      path: '/popupDetail',
      name: 'popupDetail',
      meta: {
        title: '详情'
      },
      component: resolve => {
        require(['@/pages/popupDetail.vue'], resolve)
      }
    },
    // userLabel
    {
      path: '/userLabel',
      name: 'userLabel',
      meta: {
        title: 'app版本管理'
      },
      component: resolve => {
        require(['@/pages/userLabel.vue'], resolve)
      }
    },
    {
      path: '/userLabelDetail',
      name: 'userLabelDetail',
      meta: {
        title: '详情'
      },
      component: resolve => {
        require(['@/pages/userLabelDetail.vue'], resolve)
      }
    },
    {
      path: '/channel',
      name: 'channel',
      meta: {
        title: '渠道管理'
      },
      component: resolve => {
        require(['@/pages/channel.vue'], resolve)
      }
    },
    {
      path: '/chatRoom',
      name: 'chatRoom',
      meta: {
        title: '聊天室'
      },
      component: resolve => {
        require(['@/pages/chatRoom.vue'], resolve)
      }
    },
    {
      path: '/chatRoomSer',
      name: 'chatRoomSer',
      meta: {
        title: '在线客服'
      },
      component: resolve => {
        require(['@/pages/chatRoomSer.vue'], resolve)
      }
    },
    {
      path: '/welfare',
      name: 'welfare',
      meta: {
        title: '每日福利抽奖'
      },
      component: resolve => {
        require(['@/pages/welfare.vue'], resolve)
      }
    },
    {
      path: '/dailyAttendance',
      name: 'dailyAttendance',
      meta: {
        title: '每日签到配置'
      },
      component: resolve => {
        require(['@/pages/dailyAttendance.vue'], resolve)
      }
    },
    {
      path: '/welfareDetail',
      name: 'welfareDetail',
      meta: {
        title: '每日福利抽奖编辑'
      },
      component: resolve => {
        require(['@/pages/welfareDetail.vue'], resolve)
      }
    },
    {
      path: '/welfareBack',
      name: 'welfareBack',
      meta: {
        title: '每日福利返佣'
      },
      component: resolve => {
        require(['@/pages/welfareBack.vue'], resolve)
      }
    },
    {
      path: '/welfareBackDetail',
      name: 'welfareBackDetail',
      meta: {
        title: '详情'
      },
      component: resolve => {
        require(['@/pages/welfareBackDetail.vue'], resolve)
      }
    },
    {
      path: '/levelConfig',
      name: 'levelConfig',
      meta: {
        title: '用户等级配置'
      },
      component: resolve => {
        require(['@/pages/levelConfig.vue'], resolve)
      }
    },
    {
      path: '/levelConfigDetail',
      name: 'levelConfigDetail',
      meta: {
        title: '用户等级配置详情'
      },
      component: resolve => {
        require(['@/pages/levelConfigDetail.vue'], resolve)
      }
    },
    {
      path: '/signinRecords',
      name: 'signinRecords',
      meta: {
        title: '签到明细'
      },
      component: resolve => {
        require(['@/pages/signinRecords.vue'], resolve)
      }
    },
    {
      path: '/rebateRecords',
      name: 'rebateRecords',
      meta: {
        title: '返利明细'
      },
      component: resolve => {
        require(['@/pages/rebateRecords.vue'], resolve)
      }
    },
    {
      path: '/ranking',
      name: 'ranking',
      meta: {
        title: '排行榜'
      },
      component: resolve => {
        require(['@/pages/ranking.vue'], resolve)
      }
    },
    {
      path: '/invitation',
      name: 'invitation',
      meta: {
        title: '邀请设置'
      },
      component: resolve => {
        require(['@/pages/invitation.vue'], resolve)
      }
    },
    {
      path: '/helpCenter',
      name: 'helpCenter',
      meta: {
        title: '帮助中心'
      },
      component: resolve => {
        require(['@/pages/helpCenter.vue'], resolve)
      }
    },
    {
      path: '/helpCenterDetail',
      name: 'helpCenterDetail',
      meta: {
        title: '帮助中心详情'
      },
      component: resolve => {
        require(['@/pages/helpCenterDetail.vue'], resolve)
      }
    },
    {
      path: '/pushManagement',
      name: 'pushManagement',
      meta: {
        title: '推送管理'
      },
      component: resolve => {
        require(['@/pages/pushManagement.vue'], resolve)
      }
    },
    {
      path: '/dryingSheet',
      name: 'dryingSheet',
      meta: {
        title: '晒单管理'
      },
      component: resolve => {
        require(['@/pages/dryingSheet.vue'], resolve)
      }
    },
    {
      path: '/platformDrying',
      name: 'platformDrying',
      meta: {
        title: '平台晒单'
      },
      component: resolve => {
        require(['@/pages/platformDrying.vue'], resolve)
      }
    },
    {
      path: '/withdrawal',
      name: 'withdrawal',
      meta: {
        title: '提现管理'
      },
      component: resolve => {
        require(['@/pages/withdrawal.vue'], resolve)
      }
    },
    {
      path: '/integral',
      name: 'integral',
      meta: {
        title: '积分发放'
      },
      component: resolve => {
        require(['@/pages/integral.vue'], resolve)
      }
    },
    {
      path: '/releaseAudit',
      name: 'releaseAudit',
      meta: {
        title: '积分发放审核'
      },
      component: resolve => {
        require(['@/pages/releaseAudit.vue'], resolve)
      }
    },
    {
      path: '/integralDetail',
      name: 'integralDetail',
      meta: {
        title: '积分发放详情'
      },
      component: resolve => {
        require(['@/pages/integralDetail.vue'], resolve)
      }
    },
    {
      path: '/releaseDetail',
      name: 'releaseDetail',
      meta: {
        title: '积分发放审核详情'
      },
      component: resolve => {
        require(['@/pages/releaseDetail.vue'], resolve)
      }
    },
    {
      path: '/supplier',
      name: 'supplier',
      meta: {
        title: '供应商管理'
      },
      component: resolve => {
        require(['@/pages/supplier.vue'], resolve)
      }
    },
    {
      path: '/addSupplier',
      name: 'addSupplier',
      meta: {
        title: '添加供应商'
      },
      component: resolve => {
        require(['@/pages/addSupplier.vue'], resolve)
      }
    },
    {
      path: '/editSupplier',
      name: 'editSupplier',
      meta: {
        title: '编辑供应商'
      },
      component: resolve => {
        require(['@/pages/editSupplier.vue'], resolve)
      }
    },
    {
      path: '/prizeAdmin',
      name: 'prizeAdmin',
      meta: {
        title: '抽奖管理'
      },
      component: resolve => {
        require(['@/pages/prizeAdmin.vue'], resolve)
      }
    },
    {
      path: '/prizeDetail',
      name: 'prizeDetail',
      meta: {
        title: '抽奖详情'
      },
      component: resolve => {
        require(['@/pages/prizeDetail.vue'], resolve)
      }
    },
    {
      path: '/guessing',
      name: 'guessing',
      meta: {
        title: '有奖竞猜记录'
      },
      component: resolve => {
        require(['@/pages/guessing.vue'], resolve)
      }
    },
    {
      path: '/guessingDetail',
      name: 'guessingDetail',
      meta: {
        title: '有奖竞猜详情'
      },
      component: resolve => {
        require(['@/pages/guessingDetail.vue'], resolve)
      }
    },
    {
      path: '/lotteryAllocation',
      name: 'lotteryAllocation',
      meta: {
        title: '淘豆竞猜配置'
      },
      component: resolve => {
        require(['@/pages/lotteryAllocation.vue'], resolve)
      }
    },
    {
      path: '/stockAdmin',
      name: 'stockAdmin',
      meta: {
        title: '库存管理'
      },
      component: resolve => {
        require(['@/pages/stockAdmin.vue'], resolve)
      }
    },
    {
      path: '/advertisingSpace',
      name: 'advertisingSpace',
      meta: {
        title: '页面管理'
      },
      component: resolve => {
        require(['@/pages/advertisingSpace.vue'], resolve)
      }
    },
    {
      path: '/addadvertisement',
      name: 'addadvertisement',
      meta: {
        title: '添加广告位'
      },
      component: resolve => {
        require(['@/pages/addadvertisement.vue'], resolve)
      }
    },
    {
      path: '/editadvertisement',
      name: 'editadvertisement',
      meta: {
        title: '编辑广告位'
      },
      component: resolve => {
        require(['@/pages/editadvertisement.vue'], resolve)
      }
    },
    {
      path: '/vajraDistrict',
      name: 'vajraDistrict',
      meta: {
        title: '首页推荐管理'
      },
      component: resolve => {
        require(['@/pages/vajraDistrict.vue'], resolve)
      }
    },
    {
      path: '/launchPage',
      name: 'launchPage',
      meta: {
        title: '首页启动页管理'
      },
      component: resolve => {
        require(['@/pages/launchPage.vue'], resolve)
      }
    },
    {
      path: '/addlaunchPage',
      name: 'addlaunchPage',
      meta: {
        title: '添加'
      },
      component: resolve => {
        require(['@/pages/addlaunchPage.vue'], resolve)
      }
    },
    {
      path: '/suspension',
      name: 'suspension',
      meta: {
        title: '悬浮图标配置'
      },
      component: resolve => {
        require(['@/pages/suspension.vue'], resolve)
      }
    },
    // {
    //   path: '/recommendation',
    //   name: 'recommendation',
    //   meta: {
    //     title: '商品推荐模块'
    //   },
    //   component: resolve => {
    //     require(['@/pages/recommendation.vue'], resolve)
    //   }
    // },
    {
      path: '/addrecommendation',
      name: 'addrecommendation',
      meta: {
        title: '添加商品推荐'
      },
      component: resolve => {
        require(['@/pages/addrecommendation.vue'], resolve)
      }
    },
    {
      path: '/editrecommendation',
      name: 'editrecommendation',
      meta: {
        title: '添加商品推荐'
      },
      component: resolve => {
        require(['@/pages/editrecommendation.vue'], resolve)
      }
    },
    // {
    //   path: '/recommendationZone',
    //   name: 'recommendationZone',
    //   meta: {
    //     title: '推荐专区'
    //   },
    //   component: resolve => {
    //     require(['@/pages/recommendationZone.vue'], resolve)
    //   }
    // },
    // {
    //   path: '/todayDeal',
    //   name: 'todayDeal',
    //   meta: {
    //     title: '今日特价'
    //   },
    //   component: resolve => {
    //     require(['@/pages/todayDeal.vue'], resolve)
    //   }
    // },
    {
      path: '/addcoupon',
      name: 'addcoupon',
      meta: {
        title: '添加优惠卷'
      },
      component: resolve => {
        require(['@/pages/addcoupon.vue'], resolve)
      }
    },
    {
      path: '/couponList',
      name: 'couponList',
      meta: {
        title: '优惠券管理'
      },
      component: resolve => {
        require(['@/pages/couponList.vue'], resolve)
      }
    },
    {
      path: '/couponDetail',
      name: 'couponDetail',
      meta: {
        title: '优惠券详情'
      },
      component: resolve => {
        require(['@/pages/couponDetail.vue'], resolve)
      }
    },
    {
      path: '/giveCoupon',
      name: 'giveCoupon',
      meta: {
        title: '赠送优惠券'
      },
      component: resolve => {
        require(['@/pages/giveCoupon.vue'], resolve)
      }
    },
    {
      path: '/exchangeCode',
      name: 'exchangeCode',
      meta: {
        title: '兑换码查询'
      },
      component: resolve => {
        require(['@/pages/exchangeCode.vue'], resolve)
      }
    },
    {
      path: '/codeRecovery',
      name: 'codeRecovery',
      meta: {
        title: '兑换码恢复'
      },
      component: resolve => {
        require(['@/pages/codeRecovery.vue'], resolve)
      }
    },
    {
      path: '/jurisdiction',
      name: 'jurisdiction',
      meta: {
        title: '权限管理'
      },
      component: resolve => {
        require(['@/pages/jurisdiction.vue'], resolve)
      }
    },
    {
      path: '/serviceManagement',
      name: 'serviceManagement',
      meta: {
        title: '客服管理'
      },
      component: resolve => {
        require(['@/pages/serviceManagement.vue'], resolve)
      }
    },
    {
      path: '/couponGift',
      name: 'couponGift',
      meta: {
        title: '优惠卷赠送'
      },
      component: resolve => {
        require(['@/pages/couponGift.vue'], resolve)
      }
    },
    {
      path: '/paymentManagement',
      name: 'paymentManagement',
      meta: {
        title: '支付策略'
      },
      component: resolve => {
        require(['@/pages/paymentManagement.vue'], resolve)
      }
    },
    {
      path: '/disableIp',
      name: 'disableIp',
      meta: {
        title: '禁用设备IP'
      },
      component: resolve => {
        require(['@/pages/disableIp.vue'], resolve)
      }
    },
    {
      path: '/disableDetail',
      name: 'disableDetail',
      meta: {
        title: '禁用详情'
      },
      component: resolve => {
        require(['@/pages/disableDetail.vue'], resolve)
      }
    },
    {
      path: '/abnormal',
      name: 'abnormal',
      meta: {
        title: '异常登录注册'
      },
      component: resolve => {
        require(['@/pages/abnormal.vue'], resolve)
      }
    },
    {
      path: '/payStrategy',
      name: 'payStrategy',
      meta: {
        title: '支付策略'
      },
      component: resolve => {
        require(['@/pages/payStrategy.vue'], resolve)
      }
    },
    {
      path: '/strategyDetail',
      name: 'strategyDetail',
      meta: {
        title: '支付策略详情'
      },
      component: resolve => {
        require(['@/pages/strategyDetail.vue'], resolve)
      }
    },
    {
      path: '/app-config',
      name: 'appConfig',
      meta: {
        title: 'App配置'
      },
      component: resolve => {
        require(['@/pages/app-config/index.vue'], resolve)
      }
    },
    {
      path: '/app-config-detail',
      name: 'appConfigDetail',
      meta: {
        title: 'App配置详情'
      },
      component: resolve => {
        require(['@/pages/app-config/detail.vue'], resolve)
      }
    },
    {
      path: '/worldCupTeam',
      name: 'worldCupTeam',
      meta: {
        title: '世界杯配置球队'
      },
      component: resolve => {
        require(['@/pages/worldCup/team.vue'], resolve)
      }
    },
    {
      path: '/worldCupGuess',
      name: 'worldCupGuess',
      meta: {
        title: '世界杯竞猜'
      },
      component: resolve => {
        require(['@/pages/worldCup/index.vue'], resolve)
      }
    },
    {
      path: '/worldCupGuessForm',
      name: 'worldCupGuessForm',
      meta: {
        title: '世界杯竞猜配置'
      },
      component: resolve => {
        require(['@/pages/worldCup/form.vue'], resolve)
      }
    },
    {
      path: '/worldCupGuessSettle',
      name: 'worldCupGuessSettle',
      meta: {
        title: '世界杯竞猜结算'
      },
      component: resolve => {
        require(['@/pages/worldCup/settle.vue'], resolve)
      }
    },
    {
      path: '/worldCupBetSetting',
      name: 'worldCupBetSetting',
      meta: {
        title: '世界杯竞猜投入设置'
      },
      component: resolve => {
        require(['@/pages/worldCup/betSetting.vue'], resolve)
      }
    },
    {
      path: '/worldCupGuessRecords',
      name: 'worldCupGuessRecords',
      meta: {
        title: '世界杯竞猜明细'
      },
      component: resolve => {
        require(['@/pages/worldCup/records.vue'], resolve)
      }
    },
  ]
});
export default router



// WEBPACK FOOTER //
// ./src/router/index.js